import { AnalysisAssetItem } from '../types';

export function getAssetCategoryMap(
  analysisAssets: { characters: AnalysisAssetItem[]; scenes: AnalysisAssetItem[]; props: AnalysisAssetItem[] },
  labels: { character: string; scene: string; prop: string },
) {
  const map = new Map<string, string>();
  analysisAssets.characters.forEach(asset => map.set(`${asset.type}:${asset.name}`, labels.character));
  analysisAssets.scenes.forEach(asset => map.set(`${asset.type}:${asset.name}`, labels.scene));
  analysisAssets.props.forEach(asset => map.set(`${asset.type}:${asset.name}`, labels.prop));
  return map;
}
